import Button from "@mui/material/Button";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UploadService from "../../../services/upload-files.service";

import http from "../../../shared/http-common";
import {confirmWrapper} from "../../../shared/confirm";

function UploadForm({dataObjectSelected, id, type, callbackFunc}) {
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const [selectedFiles, setSelectedFiles] = useState('');
    const [currentFile, setCurrentFile] = useState(undefined);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [fileInfosLocale, setFileInfosLocal] = useState([]);
    const [fileInfos, setFileInfos] = useState([]);

    useEffect(() => {
        fetchFileData();
        setCurrentFile(selectedFiles[0]);
    }, [selectedFiles, dataObjectSelected, id, token, realm, type]);

    const fetchFileData = async() => {
        const localeFiles = await UploadService.getLocaleFiles(token, realm);
        setFileInfosLocal(localeFiles.data);
        const files = await UploadService.getFiles(id, token, realm, type);
        setFileInfos(files.data);
    }

    function initFiles(files) {
        setSelectedFiles(files);
    }

    const deleteLocaleFile = useCallback(async(fileName) => {
        try {
            const response = await UploadService.deleteLocaleFile(fileName, token, realm);
            setMessage(response.data.message);
            const files = await UploadService.getLocaleFiles(token, realm);
            setFileInfosLocal(files.data);
        } catch {
            setProgress(0);
            setMessage("Fehler: die Datei konnte nicht geladen werden!");
            setCurrentFile(undefined);
        }
    }, [token, realm]);

    const upload = useCallback(async() => {
        setProgress(0);
        try {
            const response = await UploadService.upload(currentFile, token, realm, (event) => {
                setProgress(Math.round((100 * event.loaded) / event.total));
            });
            setMessage(response.data.message);
            const res = await UploadService.insertAttachment(id, currentFile, token, realm, type, dataObjectSelected.guid);
            const re2 = await UploadService.countAttachmentByObject(id, token, realm, type);
            setMessage(re2.data?.count);
            const result = await UploadService.getFiles(id, token, realm, type);
            setFileInfos(result.data);
            initFiles([]);
            if(callbackFunc instanceof Function) {
                callbackFunc();
            }
            await deleteLocaleFile(currentFile.name);
        } catch(err) {
            setProgress(0);
            setMessage("Fehler: die Datei konnte nicht geladen werden!");
            setCurrentFile(undefined);
        }
    }, [currentFile, token, dataObjectSelected, id, realm, type, deleteLocaleFile]);

    const deleteAttachment = useCallback(async(guid) => {
        if (await confirmWrapper('Soll die Datei wirklich gelöscht werden?')) {
            try {
                const response = await UploadService.deleteAttachment(guid, token, realm, type);
                if (response.data?.message) {
                    setMessage('Die Datei wurde gelöscht.');
                } else if (response.data?.message === 'not found') {
                    setMessage('Die Datei wurde nicht gefunden.');
                } else {
                    setMessage(response.data.message);
                }
                const files = await UploadService.getFiles(id, token, realm, type);
                setFileInfos(files.data);
                if (callbackFunc instanceof Function) {
                    callbackFunc();
                }
            } catch {
                setProgress(0);
                setMessage("Fehler: die Datei konnte nicht geladen werden!");
                setCurrentFile(undefined);
            }
        }
    }, [token, id, realm, type]);

    const downloadFile = async (file) => {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("attachmentId", file.id);
        formData.append("filename", file.name);
        let tableName = type === 'component' ? 'bauteil' : type;
        formData.append("attachmentTable", tableName);
        const fetchData = await http.post("/attachment/download", formData, {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        let fetchDataModified = `data:${file.mime_type};base64,${fetchData.data.base64FileContent}`;
        let a = document.createElement("a");
        a.href = fetchDataModified;
        a.download = file.name;
        a.click();
    }

    return (
        <div>
            {currentFile && (
                <div className="progress">
                    <div
                        className="progress-bar progress-bar-info progress-bar-striped"
                        role="progressbar"
                        aria-valuenow={progress}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: progress + "%" }}
                    >
                        {progress}%
                    </div>
                </div>
            )}

            <label className="btn btn-default">
                <input type="file" onChange={(e) => initFiles(e.target.files)} />
            </label>

            <button className="btn btn-success"
                    disabled={!selectedFiles}
                    onClick={() => upload()}
            >
                Upload
            </button>

            <div className="alert alert-light" role="alert">
                {message}
            </div>

            <div className="card">
                <div className="card-header">Liste der Dateien auf dem Server</div>
                <ul className="list-group list-group-flush">
                    {fileInfos &&
                        fileInfos.map((file, index) => (
                            <li className="list-group-item" key={index}>
                                <img src={`data:${file.mime_type};base64,${file.previewBase64content}`} alt=""/>
                                <div>{file.name} ({file.sizeFormatted})</div>
                                <Button onClick={()=>downloadFile(file)}>{file.name}</Button>
                                <Button onClick={()=>deleteAttachment(file.guid)}>Löschen</Button>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
}

export default UploadForm;
